import React, {FC} from 'react';
import classNames from 'classnames';
import {useCtxConfig} from 'pages/dashboard/components/FirstLook/context';

import Close from './svgs/close.inline.svg';
import Logo from './svgs/logo.inline.svg';
import {Progress} from './Progress';

import * as styles from './styles.module.scss';

interface HeaderProps {
	className?: string
}

export const Header: FC<HeaderProps> = ({className}) => {
	const {active, state} = useCtxConfig();
	return (
		<div className={classNames(styles.header, className)}>
			{active && <Progress />}
			<div className={styles.second}>
				<Logo />
				<Close onClick={state.onClose} />
			</div>
		</div>
	);
};
